import { useAppSelector } from "@/shared/lib/redux"
import { Table } from "@/shared/ui/table"
import { selectPair, selectPairGlass, selectPairGlassLoading } from "../../model"
import { ColumnDef } from "@tanstack/react-table"
import { useMemo } from "react"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { selectBonuses } from "@/entities/bonus"
import { toLocaleString } from "@/shared/lib/to-locale-string"
import BonusSvg from '@/shared/assets/images/BonusMenuIcon.svg'

export const PairGlass = () => {
    const glass = useAppSelector(selectPairGlass)
    const pair = useAppSelector(selectPair)
    const bonuses = useAppSelector(selectBonuses)
    const isGlassLoading = useAppSelector(selectPairGlassLoading)

    const bonus1 = useMemo(() => bonuses.find(bonus => bonus.id === pair.bonus1_id), [pair, bonuses])
    
    const parsed = useMemo(() => [
        ...glass.sell.map((deal) => ({ ...deal, type: 'sell' })),
        ...glass.buy.map((deal) => ({ ...deal, type: 'buy' }))
    ], [glass])

    const columns: ColumnDef<typeof parsed[0], any>[] = [
        {
            accessorFn: (deal) => (
                <div className={"text-white/70"}>
                    {deal.type === 'buy' 
                        ? "Покупка"
                        : "Продажа"
                    }
                </div>
            ),
            id: 'type',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Тип</div>,
        },
        {
            accessorFn: (deal) => deal,
            id: 'bonus',
            enableSorting: false,
            cell: info => {
                const deal: typeof parsed[0] = info.getValue()
                return (
                    <div className="font-semibold shrink-0 text-white flex justify-end">
                        {deal.type === 'buy' 
                            ? <div className="fill-color-dark text-color-primary">
                                    <BonusSvg width={24} height={24} />
                                </div>
                            : <div className="rounded-full w-6 h-6 overflow-hidden">
                                <img src={bonus1?.image} className="object-contain" alt="" />
                            </div>
                        }
                    </div>
                )
            },
            header: () => <div className="!text-start"></div>,
        },
        {
            accessorFn: (deal) => (
                <div className="font-semibold text-white">
                    {deal.price}
                </div>
            ),
            enableSorting: false,
            id: 'price',
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Ставка</div>,
        },
        {
            accessorFn: (deal) => (
                <div className="text-white">
                    {toLocaleString(deal.quantity)}
                </div>
            ),
            enableSorting: false,
            id: 'quantity',
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Обьем</div>,
        },
    ]

    return (
        <div className={'rounded-2xl screen:rounded-3xl transition-all ease-in bg-color-dark w-full px-6 py-8 screen:px-6 screen:py-8 flex flex-col'}>
            <div className="flex flex-col">
                <div className="font-manrope font-bold text-white/70 text-[22px]">
                    ОБЪЕМ: {toLocaleString(pair.current_sell_quantity)} {bonus1?.name}
                </div>
            </div>
            <div className=" h-full no-scrollbar">
                {Boolean(parsed.length) &&
                    <Table
                        columns={columns}
                        data={parsed}
                        classNames={{
                            table: '[&_th]:!border-[#E7EAEE88] [&_td]:!border-[#E7EAEE44]',
                            thead: 'table table-fixed w-full',
                            tbody: 'max-h-[400px] overflow-y-scroll block [&_tr]:table [&_tr]:table-fixed [&_tr]:w-full !w-full'
                        }}
                    />
                }
                {(!Boolean(parsed.length) && isGlassLoading) &&
                    <div className="info_panel !bg-color-dark">
                        <Loader />
                    </div>
                }
                {(!Boolean(parsed.length) && !isGlassLoading) &&
                    <NoTableData className="!bg-color-dark !px-0 !py-0 text-white/70" label="Нет активных предложений" />
                }
            </div>
        </div>
    )
}